export default "__VITE_ASSET__M79BMMD1__"